import { useEffect, useState } from "react";

export default function useAnimatedCount(target, duration = 1200) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const safeTarget = Number(target) || 0;
    if (safeTarget <= 0) {
      setCount(0);
      return undefined;
    }

    let current = 0;
    const step = safeTarget / (duration / 40);
    const intervalId = setInterval(() => {
      current += step;
      if (current >= safeTarget) {
        setCount(safeTarget);
        clearInterval(intervalId);
      } else {
        const nextVal = Math.floor(current);
        setCount(prev => prev === nextVal ? prev : nextVal);
      }
    }, 40);

    return () => clearInterval(intervalId);
  }, [target, duration]);

  return count;
}
